import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoListboxFields } from '@demo/data/demo-cipo-fields';
import { CipoListboxComponent } from '@shared/components/fields/cipo-listbox/cipo-listbox.component';
import { CipoListControl } from '@shared/components/fields/common';

@Component({
  selector: 'app-demo-cipo-listbox',
  imports: [CipoListboxComponent, FlexLayoutModule, KeyValuePipe],
  templateUrl: './demo-cipo-listbox.component.html',
})
export class DemoCipoListboxComponent {
  fb = inject(FormBuilder);
  dialog = inject(MatDialog);

  form = signal(new FormGroup<{ [x: string]: CipoListControl }>({}));

  constructor() {
    DemoListboxFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoListControl(defaultValue, props);
      this.form().addControl(name, control);
    });
  }
}
